<template>
  <simple-modal
    :id="modalId"
    show-title
    :title="getModalTitle"
    :hide-header-close="false"
    :hide-default-footer="true"
    size="xl"
  >
    <template #modal-content>
      <b-row v-if="noFiltersAvailable">
        <b-col>{{ $t('scoringProfiles.incompatibleFilters.noFilters') }}</b-col>
      </b-row>
      <b-row v-else class="mt-3" v-for="f in getFiltersData" :key="f.category">
        <b-col>
          <div class="font-weight-bold">{{ f.category }}</div>
          <div class="mt-2">{{ f.filtersString }}</div>
        </b-col>
      </b-row>
      <b-row v-if="isMOP" class="mt-3">
        <b-col>{{ $t('scoringProfiles.incompatibleFilters.mopInfo') }}</b-col>
      </b-row>
      <b-row class="mt-3 justify-content-end" v-if="hasGoToProfile">
        <b-col cols="auto">
          <b-button variant="link" size="sm" @click="$emit('go-to-profile')">
            {{ $t('scoringProfiles.incompatibleFilters.goToProfile') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </simple-modal>
</template>

<script>
import SimpleModal from '../Lib/SimpleModal.vue'

export default {
  name: 'IncompatibleFiltersModal',
  components: {
    SimpleModal,
  },
  props: {
    modalId: String,
    filtersData: {
      type: Object,
      default: () => ({}),
    },
    hasGoToProfile: Boolean,
  },
  computed: {
    getFiltersData() {
      const result =
        this.filtersData && this.filtersData.incompatibleFilters ? this.filtersData.incompatibleFilters : []

      return result.map((el) => {
        return {
          ...el,
          filtersString: el.filters.filter((f) => f !== null).join(', '),
        }
      })
    },
    isMOP() {
      return this.filtersData && this.filtersData.scoreResponseType && this.filtersData.scoreResponseType === 1
    },
    isInvestmentOption() {
      return this.filtersData && this.filtersData.scoreResponseType && this.filtersData.scoreResponseType === 3
    },
    getModalTitle() {
      return this.isInvestmentOption
        ? this.$t('scoringProfiles.incompatibleFilters.investmentOptionTitle')
        : this.$t('scoringProfiles.incompatibleFilters.title')
    },
    noFiltersAvailable() {
      return !this.getFiltersData || this.getFiltersData.length === 0
    },
  },
}
</script>
